import ICCardRecorder from './ICCardRecorder';

export default ICCardRecorder;
